import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Users
const UserListPage = lazy(() => import('src/pages/dashboard/users/list'));
const UserCreatePage = lazy(() => import('src/pages/dashboard/users/new'));

// Singers
const SingerListPage = lazy(() => import('src/pages/dashboard/singers/list'));
const SingerCreatePage = lazy(() => import('src/pages/dashboard/singers/new'));

// Poems
const PoemListPage = lazy(() => import('src/pages/dashboard/poems/list'));
const PoemCreatePage = lazy(() => import('src/pages/dashboard/poems/new'));
const PoemEditPage = lazy(() => import('src/pages/dashboard/poems/[id]/edit'));
const PoemDetailsPage = lazy(() => import('src/pages/dashboard/poems/[id]'));
const PoemVttGeneratorPage = lazy(() => import('src/pages/dashboard/poems/vtt-generator'));

// Poets
const PoetListPage = lazy(() => import('src/pages/dashboard/poets/list'));
const PoetCreatePage = lazy(() => import('src/pages/dashboard/poets/new'));
const PoetEditPage = lazy(() => import('src/pages/dashboard/poets/[id]/edit'));
const PoetDetailsPage = lazy(() => import('src/pages/dashboard/poets/[id]'));

// Tags
const TagListPage = lazy(() => import('src/pages/dashboard/tags/list'));
const TagCreatePage = lazy(() => import('src/pages/dashboard/tags/new'));
const TagEditPage = lazy(() => import('src/pages/dashboard/tags/[id]/edit'));

// Audios
const AudioListPage = lazy(() => import('src/pages/dashboard/audios/list'));
const AudioCreatePage = lazy(() => import('src/pages/dashboard/audios/new'));
const AudioEditPage = lazy(() => import('src/pages/dashboard/audios/[id]/edit'));
const AudioDetailsPage = lazy(() => import('src/pages/dashboard/audios/[id]'));

// Difficult Words
const DifficultWordListPage = lazy(() => import('src/pages/dashboard/difficult-words/list'));
const DifficultWordCreatePage = lazy(() => import('src/pages/dashboard/difficult-words/new'));

// ----------------------------------------------------------------------

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <RoleBasedGuard roles={['ADMIN']} hasContent>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </RoleBasedGuard>
    ),
    children: [
      // Poems routes
      {
        path: 'poems',
        children: [
          { element: <PoemListPage />, index: true },
          { path: 'list', element: <PoemListPage /> },
          { path: 'new', element: <PoemCreatePage /> },
          { path: 'vtt-generator', element: <PoemVttGeneratorPage /> },
          { path: ':id', element: <PoemDetailsPage /> },
          { path: ':id/edit', element: <PoemEditPage /> },
        ],
      },
      // Poets routes
      {
        path: 'poets',
        children: [
          { element: <PoetListPage />, index: true },
          { path: 'list', element: <PoetListPage /> },
          { path: 'new', element: <PoetCreatePage /> },
          { path: ':id', element: <PoetDetailsPage /> },
          { path: ':id/edit', element: <PoetEditPage /> },
        ],
      },
      // Tags routes
      {
        path: 'tags',
        children: [
          { element: <TagListPage />, index: true },
          { path: 'list', element: <TagListPage /> },
          { path: 'new', element: <TagCreatePage /> },
          { path: ':id/edit', element: <TagEditPage /> },
        ],
      },
      // Audios routes
      {
        path: 'audios',
        children: [
          { element: <AudioListPage />, index: true },
          { path: 'list', element: <AudioListPage /> },
          { path: 'new', element: <AudioCreatePage /> },
          { path: ':id', element: <AudioDetailsPage /> },
          { path: ':id/edit', element: <AudioEditPage /> },
        ],
      },
      // Users routes
      {
        path: 'users',
        children: [
          { element: <UserListPage />, index: true },
          { path: 'list', element: <UserListPage /> },
          { path: 'new', element: <UserCreatePage /> },
        ],
      },
      // Singers routes
      {
        path: 'singers',
        children: [
          { element: <SingerListPage />, index: true },
          { path: 'list', element: <SingerListPage /> },
          { path: 'new', element: <SingerCreatePage /> },
        ],
      },
      // Difficult Words routes
      {
        path: 'difficult-words',
        children: [
          { element: <DifficultWordListPage />, index: true },
          { path: 'list', element: <DifficultWordListPage /> },
          { path: 'new', element: <DifficultWordCreatePage /> },
        ],
      },
    ],
  },
];
